import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './stylesheet.css';
import App from './App';
import './i18n'; // i18next initialization
import './firebase'; // Import to initialize the Firebase singleton.
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Suspense fallback={<div>Loading...</div>}>
        <HelmetProvider>
            <Elements stripe={stripePromise}>
                <App />
            </Elements>
        </HelmetProvider>
    </Suspense>
);
